<template>
  <div>
    <div class="d-flex flex-row-reverse">
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="getHistoryLabels" icon v-bind="attrs" v-on="on">
            <v-icon class="pa-1">mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>Reload</span>
      </v-tooltip>
    </div>
    <div v-if="historyModelLocal.length > 0">
      <div v-for="history in historyModelLocal" :key="history.address">
        <div class="text-overline px-2">
          <strong>{{ history.label }}</strong>
        </div>
        <v-row class="px-1">
          <v-col>
            <InputsExcelTextArea
              v-model="history.value"
              class="mb-4"
              :address="history.address"
              outlined
              hide-details
              dense
              auto-grow
            />
          </v-col>
        </v-row>
      </div>
    </div>
    <div v-else>
      <div v-if="historyLabelsLoading">
        <v-overlay :value="historyLabelsLoading">
          <div>
            <v-progress-circular
              size="22"
              class="mr-2"
              indeterminate
            ></v-progress-circular>
            <span>Getting history...</span>
          </div>
        </v-overlay>
      </div>
      <div v-else>
        <v-alert class="mt-4" type="info" border="left" color="yellow darken-4">
          No history found...
        </v-alert>
      </div>
    </div>
  </div>
</template>

<script>
const Excel = window.Excel
import InputsExcelTextArea from '@/components/inputs/excel/InputsExcelTextArea'
export default {
  components: {
    InputsExcelTextArea,
  },
  props: {
    historyModel: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      historyLabelsLoading: false,
    }
  },
  computed: {
    historyModelLocal: {
      get() {
        return this.historyModel
      },
      set() {
        this.$emit('input')
      },
    },
  },
  mounted() {
    // this.getHistoryLabels()
  },
  methods: {
    getLetter(col) {
      switch (col) {
        case 0:
          return 'A'
        case 1:
          return 'B'
        case 2:
          return 'C'
        case 3:
          return 'D'
        case 4:
          return 'E'
        case 5:
          return 'F'
        case 6:
          return 'G'
        case 7:
          return 'H'
        case 8:
          return 'I'
        case 9:
          return 'J'
        case 10:
          return 'K'
        case 11:
          return 'L'
        case 12:
          return 'M'
        case 13:
          return 'N'
        case 14:
          return 'O'
        case 15:
          return 'P'
        case 16:
          return 'Q'
        case 17:
          return 'R'
        default:
          return ''
      }
    },
    async getAddress(text, rowOffset, colOffset) {
      const position = await this.findRowPosition(text)

      const row = position.row + rowOffset
      const col = position.col + colOffset

      const rowVisual = row + 1
      const address = this.getLetter(col) + String(rowVisual)
      return address
    },
    async getHistoryLabels() {
      this.historyModelLocal = []
      this.historyLabelsLoading = true
      const positionStart = await this.findRowPosition(
        'History/ development/ changes'
      )
      const rowStart = positionStart.row + 2

      const positionEnd = await this.findRowPosition('Current risk evaluation')
      const rowEnd = positionEnd.row - 1

      for (let r = rowStart; r < rowEnd; r++) {
        const label = await this.getRangeValue(r, positionStart.col)
        const address = await this.getAddress(label, 0, 1)
        const historyObj = {
          label: label,
          address: address,
          value: '',
        }
        this.historyModelLocal.push(historyObj)
      }

      this.historyLabelsLoading = false
    },
    getRangeValue(row, col) {
      return Excel.run(async function (context) {
        const sheet = context.workbook.worksheets.getActiveWorksheet()

        const range = sheet.getRangeByIndexes(row, col, 1, 1)
        range.load('values')
        await context.sync()
        console.log('cell values', range.values[0][0])
        return range.values[0][0]
      })
    },
    findRowPosition(text) {
      return Excel.run(async function (context) {
        const sheet = context.workbook.worksheets.getActiveWorksheet()

        const foundRange = sheet.findAllOrNullObject(text, {
          completeMatch: true,
          matchCase: false,
        })
        foundRange.load('areas')
        await context.sync()

        if (!foundRange.isNullObject) {
          const range = sheet.getRange(foundRange.areas.items[0].address)
          range.load('rowIndex, columnIndex')
          await context.sync()
          return {
            row: range.rowIndex,
            col: range.columnIndex,
          }
        } else {
          return null
        }
      })
    },
  },
}
</script>
